// extracted by mini-css-extract-plugin
export default {"cls1":"UserForm-InlineButton_cls1__4X+Ff","cls2":"UserForm-InlineButton_cls2__Y-vbB UserForm-InlineButton_cls1__4X+Ff"};